import Modal from '../Modal/modal';
import { Button } from 'fc/components/Button';

interface DocumentReviewModalProps {
  modalConfig: {
    title: string;
    onClose: () => void;
    isOpen: boolean;
    handleSubmit: () => void;
  };
}

export const DeleteModal: React.FC<DocumentReviewModalProps> = ({
  modalConfig: { title, onClose, isOpen, handleSubmit },
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onOpenChange={handleClose}
      title={title}
      titleClassName="font-p22Mackinac font-100"
    >
      <div className="flex justify-end gap-3">
        <Button
          className="bg-white border-gray-300 mt-12 mr-8 text-black"
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="destructive"
          className='mt-12'
          onClick={() => {
            handleSubmit();
          }}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};
